// extracted by mini-css-extract-plugin
export var chevronIcon = "_e3-2";
export var teamName = "_e3-1";
export var teamSwitcherButton = "_e3-0";